import React, { FC, useEffect, useState } from 'react';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import MuiSwitch, { SwitchProps } from '@mui/material/Switch';

interface Props extends SwitchProps {
  label?: string;
}

export const Switch: FC<Props> = ({ label, checked: checkedProp = false, onChange, ...props }) => {
  const [checked, setChecked] = useState<boolean>(checkedProp);

  useEffect(() => {
    if (checkedProp === checked) {
      return;
    }

    setChecked(checkedProp);
  }, [checkedProp]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, newChecked: boolean) => {
    if (newChecked === null) {
      return;
    }

    onChange?.(event, newChecked);
    setChecked(newChecked);
  };

  return (
    <Stack alignItems="center">
      {!!label && <FormLabel sx={{ fontSize: '0.75rem', color: 'text.secondary', marginRight: 1 }}>{label}</FormLabel>}
      <MuiSwitch
        sx={(theme) => ({
          width: 28,
          height: 16,
          padding: 0,
          display: 'flex',
          '&:active': {
            '& .MuiSwitch-thumb': {
              width: 15,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
              transform: 'translateX(9px)',
            },
          },
          '& .MuiSwitch-switchBase': {
            padding: '2px !important',
            '&.Mui-checked': {
              transform: 'translateX(12px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#9DCFF5' : '#3B6EB7',
              },
            },
          },
          '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: 12,
            height: 12,
            borderRadius: 6,
            transition: theme.transitions.create(['width'], {
              duration: 200,
            }),
          },
          '& .MuiSwitch-track': {
            borderRadius: 16 / 2,
            opacity: 1,
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
            boxSizing: 'border-box',
          },
        })}
        checked={checked}
        onChange={handleChange}
        {...props}
      />
    </Stack>
  );
};
